// extracted by mini-css-extract-plugin
export default {"side":"sidebar_side__GCjYy","line":"sidebar_line__8Togz"};